import { TextView } from '../TextView';
import { observer } from 'mobx-react';

@observer
export class PhoneNumberView extends TextView
{

}
